<template>
  <v-col cols="12" sm="12" md="4">
    <v-card>
      <v-card-title class="text-h5 text-uppercase"> Top 5 Shorts - {{ country }} </v-card-title>

      <v-card-text>
        <v-table>
          <template #default>
            <thead>
              <tr>
                <th class="text-left">Name</th>
                <th class="text-left">Active Shorts</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in results" :key="item.name">
                <td>
                  <router-link
                    class="text-uppercase"
                    :to="'/short/short_position_issuer/' + item.permalink"
                  >
                    {{ item.issuer_name }}</router-link
                  >
                </td>
                <td>{{ rounded_number(item.net_short_position) }}</td>
              </tr>
            </tbody>
          </template>
        </v-table>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import { apiRoot } from '@/store/api'
import debounce from 'lodash/debounce'

// Mixins
import FormattersMixin from '@/mixins/formatters'

export default {
  components: {},
  mixins: [FormattersMixin],
  props: {
    country: String
  },

  data() {
    return {
      loading: false,
      results: [],
      criteria: {
        country: null
      }
    }
  },

  mounted() {
    this.updateData()
  },

  methods: {
    updateData() {
      this.loading = true
      this.criteria.country = this.country
      apiRoot
        .post('/short_position/top_positions_by_country', this.criteria)
        .then(response => {
          this.results = response.data
        })
        .catch(error => {
          useAppStore().showNotification({
            type: 'error',
            text: (error.response && error.response.data) || error.message
          })
        })
        .then(() => (this.loading = false))
    }
  }
}
</script>
